import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutSnapshot from "./sections/AboutSnapshot";
import OurServicesOverview from "./sections/OurServicesOverview";
import Testimonials from "./sections/Testimonials";
import ContactCallToAction from "./sections/ContactCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutSnapshot />
      <OurServicesOverview />
      <Testimonials />
      <ContactCallToAction />
      <Footer />
    </div>;
}